var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { Draggable } from '@progress/kendo-react-common';
/**
 * @hidden
 */

var keys = ['n', 'e', 's', 'w', 'se', 'sw', 'ne', 'nw'];
/**
 * @hidden
 */

var ResizeHandlers = function (_super) {
  __extends(ResizeHandlers, _super);

  function ResizeHandlers() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ResizeHandlers.prototype.render = function () {
    var _this = this;

    return React.createElement("div", null, " ", keys.map(function (key, index) {
      return React.createElement(Draggable, {
        key: index,
        onDrag: function onDrag(data) {
          var event = data.event;
          event.originalEvent.preventDefault();

          _this.props.onResize(event, {
            end: false,
            direction: key
          });
        },
        onRelease: function onRelease(data) {
          var event = data.event;
          event.originalEvent.preventDefault();

          _this.props.onResize(event, {
            end: true,
            direction: key
          });
        }
      }, React.createElement("div", {
        className: 'k-resize-handle k-resize-' + key,
        style: {
          display: 'block',
          touchAction: 'none'
        }
      }));
    }));
  };

  return ResizeHandlers;
}(React.Component);

export { ResizeHandlers };